/**
 * Shared AJAX handler for careers interest forms (FormSubmit).
 */
(function () {
  function setStatus(form, message, state) {
    var status = form.querySelector('[data-careers-status]');
    if (!status) return;
    status.hidden = false;
    status.dataset.state = state || 'success';
    status.textContent = message;
  }

  function handleSubmit(event) {
    var form = event.currentTarget;
    event.preventDefault();

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    var submit = form.querySelector('[type="submit"]');
    var original = submit ? submit.innerHTML : '';
    var successMessage =
      form.getAttribute('data-success-message') ||
      "Thanks! We'll keep your info on file and reach out if a role pops up that fits.";

    if (submit) {
      submit.disabled = true;
      submit.querySelector('span').textContent = 'Submitting...';
    }

    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      headers: {
        Accept: 'application/json',
      },
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Submission failed');
        }
        return response.json().catch(function () {
          return {};
        });
      })
      .then(function () {
        form.reset();
        setStatus(form, successMessage, 'success');
        if (submit) {
          submit.disabled = false;
          submit.innerHTML = original;
        }
      })
      .catch(function () {
        setStatus(
          form,
          'There was an error submitting your details. Please try again or email info@hairsupplies.com.au.',
          'error'
        );
        if (submit) {
          submit.disabled = false;
          submit.innerHTML = original;
        }
      });
  }

  function init() {
    document.querySelectorAll('[data-careers-form]').forEach(function (form) {
      if (form.dataset.careersBound) return;
      form.dataset.careersBound = 'true';
      form.addEventListener('submit', handleSubmit);
      var file = form.querySelector('input[type="file"]');
      if (file) {
        file.addEventListener('change', function () {
          var label = form.querySelector('[data-file-label]');
          if (!label) return;
          label.textContent = file.files && file.files[0] ? file.files[0].name : 'Choose a file';
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
